import { theme } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

import { TRANSITION_DURATION_IN_MS } from './constants';

export const image = css`
  transition: opacity ${TRANSITION_DURATION_IN_MS}ms;
  opacity: 0;

  &[data-is-visible='true'] {
    opacity: 1;
  }
`;

export const placeholder = css`
  position: absolute;
  background-color: ${theme.colors.neutralLight};
  width: 100%;
  height: 100%;
`;
